module.exports = __webpack_public_path__ + "static/media/emj22.b33ff9c3.svg";